import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
} from 'antd';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
  validateTextOnly,
  validatePhoneNumber,
  validateNumberOnly,
  validateCitizenId,
  getRedirectPath,
} from '../../functions';
// import { getRedirectPath } from '../../functions';
import NetworkData from './network';
import styles from './index.module.scss';
import Logo from '../../components/Logo';
import Logo2 from '../../components/Logo2';
import './styles.scss';

import {
  ONETRUST_PRIVACY,
  ONETRUST_PRIVACY_POLICY_URL,
  ONETRUST_SHARED_DATA,
  ONETRUST_TERMS_OF_USE_URL,
  ONETRUST_API_URL,
} from '../../config';
import { getStates } from '../../services/api';

export type Props = {};

const Register: React.FC<Props> = (props) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isTermsOfUse, setTermsOfUse] = useState<any>();
  const [isProvactyPolicy, setProvactyPolicy] = useState<any>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isAgreement, setIsAgreement] = useState<any>(false);
  const [isAgreementData, setIsAgreementData] = useState<any>(false);
  const [isNetwork, setIsNetwork] = useState<any>(false);
  const [isCheckedScgFamily, setIsCheckedScgFamily] =
    useState<any>(false);

  const [isChecker, setIsChecker] = useState<any>(false);
  const [isCheckedNew, setIsCheckedNew] = useState<any>(false);
  const [isCheckedShareData, setIsCheckedShareDat] =
    useState<any>(false);
  const [isScrolling, setIsScrolling] = useState<any>(true);
  const [isScrollingData, setIsScrollingData] = useState<any>(true);
  const [isScrollingInModal, setIsScrollingInModal] =
    useState<any>(true);
  const [isPrivacy, setIsPrivacy] = useState<any>(true);
  const [OneTrust, setOneTrust] = useState<any>(
    `${ONETRUST_API_URL}`
  );
  const [form] = Form.useForm();
  const [isScGConnectable, setIsScGConnectable] = useState<any>(true);
  const [visibleModal, setVisibleModal] = useState<any>(false);
  const [term, setTerm] = useState<any>();
  const [states, setStates] = useState<any>();

  const getTerm = async () => {
    const allOrder = await axios.get(`/term-of-use/role?role=buyer`);
    setTerm(htmlDecode(allOrder.data.termOfUse));
  };

  const getState = async () => {
    setStates(await getStates());
    return;
  };

  const htmlDecode = (content: any) => {
    let e = document.createElement('div');
    e.innerHTML = content;

    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  };

  const onSubmit = async (values: any) => {
    const lineUserId = searchParams.get('refLineUserId');

    if (isCheckedScgFamily) {
      const memberExisted = await checkExistMemberScgFamily();
      if (memberExisted) {
        setIsScGConnectable(false);
        message.warning('ลงทะเบียนไม่สำเร็จ');
        return;
      }
    }

    let body = {
      ...values,
      ...(lineUserId && { lineUserId }),
      ...(isCheckedScgFamily &&
        isScGConnectable && { scgFamily: isCheckedScgFamily }),
      userType: 'buyer',
      isCheckedNew: isCheckedNew,
      isCheckedShareData: isCheckedShareData,
      registerType: 'buyer_online',
    };

    try {
      const redirect = searchParams.get('redirect');
      const isLogin = await axios.post(`/auth/register`, body);

      if (isLogin?.data?.user?._id) {
        const datetoset = new Date();

        if (isCheckedScgFamily) {
          if (await checkExistMemberScgFamily()) {
            const result = await connectToScgFamily(
              isLogin?.data?.user?._id
            );
            if (!result) {
              message.warning('เชื่อมต่อ scg-family ไม่สำเร็จ');
            }
          }
        }

        if (isChecker) {
          axios.post(OneTrust, {
            identifier: isLogin?.data?.user?.phone,
            requestInformation: `${ONETRUST_PRIVACY.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_PRIVACY.ID}`,
                TransactionType: isCheckedNew
                  ? 'CONFIRMED'
                  : 'WITHDRAWN',
              },
            ],
          });

          axios.post(OneTrust, {
            identifier: isLogin?.data?.user?.phone,
            requestInformation: `${ONETRUST_SHARED_DATA.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_SHARED_DATA.ID}`,
                TransactionType: isCheckedShareData
                  ? 'CONFIRMED'
                  : 'WITHDRAWN',
              },
            ],
          });

          const checkBoxsUser = await axios.post(`/pdpa-user`, {
            userId: isLogin?.data?.user?._id,
            version: '1',
            pdpa: {
              privacyPolicy: true,
              termsConditions: true,
              news: isCheckedNew,
              personalInformation: isCheckedShareData,
            },
            pdpaDetail: {
              privacyPolicy: {
                version: isProvactyPolicy.version,
                acceptDate: datetoset,
              },
              termsConditions: {
                version: 1,
                acceptDate: datetoset,
              },
              news: {
                version: 1,
                acceptDate: datetoset,
              },
              personalInformation: {
                version: 1,
                acceptDate: datetoset,
              },
            },
          });
          const checkBoxsLog = await axios.post(`/pdpa-log`, {
            userId: isLogin?.data?.user?._id,
            version: '1',
            pdpa: {
              privacyPolicy: true,
              termsConditions: true,
              news: isCheckedNew,
              personalInformation: isCheckedShareData,
            },
            pdpaDetail: {
              privacyPolicy: {
                version: isProvactyPolicy.version,
                acceptDate: datetoset,
              },
              termsConditions: {
                version: 1,
                acceptDate: datetoset,
              },
              news: {
                version: 1,
                acceptDate: datetoset,
              },
              personalInformation: {
                version: 1,
                acceptDate: datetoset,
              },
            },
          });
        } else {
          axios.post(OneTrust, {
            identifier: isLogin?.data?.user?.phone,
            requestInformation: `${ONETRUST_PRIVACY.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_PRIVACY.ID}`,
                TransactionType: isCheckedNew
                  ? 'CONFIRMED'
                  : 'WITHDRAWN',
              },
            ],
          });

          axios.post(OneTrust, {
            identifier: isLogin?.data?.user?.phone,
            requestInformation: `${ONETRUST_SHARED_DATA.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_SHARED_DATA.ID}`,
                TransactionType: isCheckedShareData
                  ? 'CONFIRMED'
                  : 'WITHDRAWN',
              },
            ],
          });

          const checkBoxsUser = await axios.post(`/pdpa-user`, {
            userId: isLogin?.data?.user?._id,
            version: 1,
            pdpa: {
              privacyPolicy: false,
              termsConditions: false,
              news: isCheckedNew,
              personalInformation: isCheckedShareData,
            },
            pdpaDetail: {
              privacyPolicy: {
                version: isProvactyPolicy.version,
                acceptDate: datetoset,
              },
              termsConditions: {
                version: 1,
                acceptDate: datetoset,
              },
              news: {
                version: 1,
                acceptDate: datetoset,
              },
              personalInformation: {
                version: 1,
                acceptDate: datetoset,
              },
            },
          });
          const checkBoxsLog = await axios.post(`/pdpa-log`, {
            userId: isLogin?.data?.user?._id,
            version: '1',
            pdpa: {
              privacyPolicy: false,
              termsConditions: false,
              news: isCheckedNew,
              personalInformation: isCheckedShareData,
            },
            pdpaDetail: {
              privacyPolicy: {
                version: isProvactyPolicy.version,
                acceptDate: datetoset,
              },
              termsConditions: {
                version: 1,
                acceptDate: datetoset,
              },
              news: {
                version: 1,
                acceptDate: datetoset,
              },
              personalInformation: {
                version: 1,
                acceptDate: datetoset,
              },
            },
          });
        }
      }
      message.success('สมัครสมาชิกสำเร็จ!');

      if (lineUserId) {
        const { data } = await axios.get(
          `/auth/get-user-with-line-user-id?userId=${lineUserId}`
        );

        if (data?.user?._id) {
          localStorage.setItem('token', data.token);

          axios.interceptors.request.use(function (config: any) {
            config.headers.Authorization = `Bearer ${data.token}`;

            return config;
          });

          dispatch({
            type: 'UPDATE_USER',
            data: data?.user,
          });

          setTimeout(() => {
            const path = getRedirectPath(redirect);
            window.location.href = path;
          }, 1000);
        } else {
          navigate(
            `/register?refLineUserId=${lineUserId}&redirect=${redirect}`
          );
        }
      } else {
        setTimeout(() => {
          navigate(`/login?redirect=${redirect}&tel=${values.phone}`);
        }, 1000);
      }
    } catch (error: any) {
      const err = error?.response?.data?.error;
      if (err?.code === 'duplicate-email') {
        message.warning('อีเมลนี้ถูกใช้งานแล้ว!');
      } else if (err?.code === 'duplicate-phone') {
        message.warning('เบอร์โทรนี้ถูกใช้งานแล้ว!');
      } else {
        message.warning(error.message);
      }

      setIsLoading(false);
    }
  };

  const openModalData = () => {
    setIsAgreementData(true);
  };

  const openModal = () => {
    setIsAgreement(true);
  };

  const openModalNetwork = () => {
    setIsNetwork(true);
  };

  const clossModal = () => {
    setIsAgreement(false);
    setIsAgreementData(false);
    setIsNetwork(false);
  };

  const isBottom = (el: any) => {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  };

  const onScroll = () => {
    const wrappedElement = document.getElementById('bottomModal');

    if (isBottom(wrappedElement)) {
      setIsScrolling(false);
      document.removeEventListener('scroll', onScroll);
    }
  };

  const onScrollData = () => {
    const wrappedElement = document.getElementById('bottomModal');

    if (isBottom(wrappedElement)) {
      setIsScrollingData(false);
      document.removeEventListener('scroll', onScrollData);
    }
  };

  const setIsCheckerbox = (value: any) => {
    setIsChecker(value);
    setIsPrivacy(true);
    setIsScrollingInModal(true);
  };

  useEffect(() => {
    getTerm();
    setFormJob(3);
    getState();
    const ONETRUST_TERMS_OF_USE = `${ONETRUST_TERMS_OF_USE_URL}`;
    fetch(ONETRUST_TERMS_OF_USE)
      .then((response) => response.json())
      .then((jsonData) => {
        const noticeContent =
          jsonData.notices[Object.keys(jsonData.notices)[0]];
        const contentDetail = {
          content: noticeContent.content,
          version: noticeContent.publicVersion,
        };
        setTermsOfUse(contentDetail);
      })
      .catch((error) => {
        console.error(error);
      });
    const ONETRUST_PROVACTY_POLICY = `${ONETRUST_PRIVACY_POLICY_URL}`;
    fetch(ONETRUST_PROVACTY_POLICY)
      .then((response) => response.json())
      .then((jsonData) => {
        const provactyPolicy =
          jsonData.notices[Object.keys(jsonData.notices)[0]];
        const provactyPolicyDetail = {
          content: provactyPolicy.content,
          version: provactyPolicy.publicVersion,
        };
        setProvactyPolicy(provactyPolicyDetail);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (!isPrivacy && !isScrollingInModal) {
      setIsChecker(true);
    }
  }, [isPrivacy, isScrollingInModal]);

  const checkExistMemberScgFamily = async () => {
    const result = await axios.post(
      `/scg-family/check-existing-member`,
      {
        mobileNo: form.getFieldValue('phone'),
        citizenId: form.getFieldValue('citizenId'),
      }
    );

    return result.data?.existsMember ?? false;
  };

  const connectToScgFamily = async (userId: any) => {
    const result = await axios.post(`/scg-family/binding`, {
      userId: userId,
      mobileNo: form.getFieldValue('phone'),
    });
    if (!result.data.success) {
      return false;
    }
    return true;
  };

  const handleCheckScgFamily = async (e: any) => {
    if (e.target.checked) setVisibleModal(true);
    else setIsCheckedScgFamily(e.target.checked);
  };

  const setFormJob = (v: any) => {
    form.setFieldsValue({
      ...form,
      job: v,
    });
  };

  const JobDropdown = () => {
    const options = [
      { value: 1, label: 'ผู้รับเหมาก่อสร้าง' },
      { value: 2, label: 'อื่นๆ' },
      { value: 3, label: 'ช่างรับเหมาท่ัวไป' },
      { value: 4, label: 'สถาปนิก/นักออกแบบ' },
      { value: 5, label: 'วิศวกร' },
      { value: 6, label: 'พนักงานเอกชน' },
      { value: 7, label: 'ค้าขาย/ธุรกิจส่วนตัว' },
      { value: 8, label: 'ข้าราชการ/รัฐวิสากิจ' },
    ];

    return (
      <Select
        defaultValue={3}
        style={{ minWidth: 120 }}
        onChange={(v) => setFormJob(v)}
      >
        {options.map((option) => (
          <Option value={option.value} key={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    );
  };

  const handleConfirmModal = () => {
    setIsCheckedScgFamily(true);
    setVisibleModal(false);
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.leftSection}>
          <Logo />
        </div>
        <div className={styles.rightSection}>
          <div className={styles.container}>
            <div className={styles.logoMobileWrapper}>
              <Logo2 />
            </div>
            <h1 className={styles.header}>ลงทะเบียนพร้อมดี</h1>
            <div className={styles.formWrapper}>
              <Form
                form={form}
                name="basic"
                autoComplete="off"
                layout="vertical"
                labelWrap
                onFinish={onSubmit}
              >
                <Row gutter={30}>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="ชื่อ"
                      name="firstName"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณาป้อนชื่อ!',
                        },
                      ]}
                    >
                      <Input
                        onKeyPress={(event) =>
                          validateTextOnly(event)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="นามสกุล"
                      name="lastName"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณาป้อนนามสกุล!',
                        },
                      ]}
                    >
                      <Input
                        onKeyPress={(event) =>
                          validateTextOnly(event)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="โทรศัพท์"
                      name="phone"
                      rules={[
                        {
                          required: true,
                          validator: validatePhoneNumber,
                        },
                      ]}
                    >
                      <Input
                        onKeyPress={(event) =>
                          validateNumberOnly(event)
                        }
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="อีเมล์"
                      name="email"
                      rules={[
                        {
                          required: false,
                          message: 'กรุณาป้อนอีเมล์!',
                        },
                        {
                          validator: async (_, value) => {
                            try {
                              if (value !== undefined) {
                                await axios.post(
                                  `/users/check-email-and-username?type=buyer`,
                                  { email: value }
                                );
                              }
                            } catch (error) {
                              return Promise.reject(
                                new Error('อีเมลนี้ถูกใช้งานแล้ว!')
                              );
                            }
                          },
                        },
                        {
                          validator: async (_, value) => {
                            const result = String(value)
                              .toLowerCase()
                              .match(
                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                              );

                            if (value) {
                              if (!(result && result.length)) {
                                return Promise.reject(
                                  new Error(
                                    'กรุณากรอกอีเมลให้ถูกต้อง!'
                                  )
                                );
                              }
                            }
                          },
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="จังหวัดที่ท่านอาศัยอยู่ปัจจุบัน"
                      name="currentState"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณเลือกจังหวัด!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option: any) =>
                          option.label.indexOf(input.toLowerCase()) >=
                          0
                        }
                        options={states}
                        placeholder="จังหวัด"
                      ></Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label='ช่าง หรือ เจ้าของบ้าน'
                      name='position'
                      rules={[
                        {
                          required: true,
                          message: 'กรุณเลือกใครกำลังหาซื้อวัสดุก่อสร้าง!',
                        },
                      ]}
                    >
                      <Select
                        placeholder='ช่าง หรือ เจ้าของบ้าน'
                      >
                        <Option value='technician'>ช่าง</Option>
                        <Option value='house-owner'>เจ้าของบ้าน</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    lg={24}
                    style={{
                      marginTop: '1.25rem',
                      marginBottom: isCheckedScgFamily
                        ? '1rem'
                        : '1.5rem',
                    }}
                  >
                    <div className={styles.scgFamCheckbox}>
                      <div className={styles.scgFamCheckboxInput}>
                        <Checkbox
                          checked={isCheckedScgFamily}
                          onChange={(e) => handleCheckScgFamily(e)}
                          className={[
                            styles.customCheckbox,
                            'custom-checkbox',
                          ].join(' ')}
                        >
                          กดเพื่อเลือก
                        </Checkbox>
                        <img
                          style={{ height: 48 }}
                          src="/images/scg-family-points.png"
                        />
                      </div>
                      <div className={styles.scgFamCheckboxText}>
                        เชื่อมต่อบัญชีหรือสมัครสมาชิก
                        <span style={{ margin: '0 0.25rem' }}>
                          <a
                            style={{
                              color: '#fff',
                              textDecoration: 'underline',
                            }}
                            href="https://www.scgfamily.com/home"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            SCG Family
                          </a>
                        </span>
                        {/* <br /> */}
                        เพื่อสะสมคะแนนและรับสิทธิประโยชน์มากมาย
                      </div>
                    </div>
                  </Col>

                  {isCheckedScgFamily && (
                    <>
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label="อาชีพ"
                          name="job"
                          rules={[
                            {
                              required: isCheckedScgFamily,
                              message: 'กรุณาป้อนอาชีพ',
                            },
                          ]}
                        >
                          <JobDropdown />
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        lg={12}
                        style={{ marginBottom: 24 }}
                      >
                        <Form.Item
                          label="เลขประจำตัวประชาชน"
                          name="citizenId"
                          rules={[
                            {
                              required: isCheckedScgFamily,
                              validator: validateCitizenId,
                            },
                          ]}
                        >
                          <Input
                            onKeyPress={(event) =>
                              validateNumberOnly(event)
                            }
                            maxLength={13}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}

                  <div className={styles.persuadetext}>
                    ไม่พลาดทุกสิทธิประโยชน์เพียงให้ความยินยอมกับเรา
                  </div>

                  <Col xs={24} lg={24} style={{ marginBottom: 20 }}>
                    <div
                      style={{ display: 'flex', marginBottom: 10 }}
                    >
                      <Checkbox
                        disabled={!isChecker}
                        checked={isChecker}
                        onChange={(e) =>
                          setIsCheckerbox(e.target.checked)
                        }
                        style={{ marginTop: 2, marginRight: 10 }}
                      ></Checkbox>
                      <div>
                        <span style={{ fontSize: 14 }}>
                          ข้าพเจ้าเข้าใจและตกลงตาม{' '}
                        </span>
                        <span
                          style={{
                            fontSize: 14,
                            color: '#1890FF',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                          onClick={openModal}
                        >
                          ข้อกำหนดและเงื่อนไข
                        </span>
                        <span>
                          {' '}
                          รวมทั้งเข้าใจถึงเรื่องการเก็บ ใช้
                          และเปิดเผยข้อมูลส่วนบุคคลตาม{' '}
                        </span>
                        <span
                          style={{
                            fontSize: 14,
                            color: '#1890FF',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                          onClick={openModalData}
                        >
                          นโยบายความเป็นส่วนตัว
                        </span>
                        <span style={{ fontSize: 14 }}>
                          {' '}
                          (โปรดกดอ่าน ข้อกำหนดและเงื่อนไข และ
                          นโยบายความเป็นส่วนตัว)
                        </span>
                      </div>
                      <Modal
                        visible={isAgreement}
                        centered
                        footer={false}
                        closeIcon
                        className={styles.modalPolicy}
                      >
                        <Card
                          bordered={false}
                          className={styles.cardBody}
                          onScroll={() => onScroll()}
                        >
                          <div
                            className="otnotice"
                            dangerouslySetInnerHTML={{
                              __html: term ? term : '',
                            }}
                          ></div>
                          <div
                            id="bottomModal"
                            style={{ marginTop: 50 }}
                          ></div>
                        </Card>
                        <div
                          style={{
                            marginTop: 30,
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Checkbox
                            disabled={isScrolling}
                            checked={!isScrollingInModal}
                            onChange={() =>
                              setIsScrollingInModal(
                                !isScrollingInModal
                              )
                            }
                            style={{ padding: 6 }}
                          >
                            ยอมรับเงื่อนไข
                          </Checkbox>
                          <Button
                            onClick={clossModal}
                            disabled={isScrollingInModal}
                          >
                            ตกลง
                          </Button>
                        </div>
                      </Modal>
                      <Modal
                        visible={isAgreementData}
                        centered
                        footer={false}
                        closeIcon
                        className={styles.modalPolicy}
                      >
                        <Card
                          bordered={false}
                          className={styles.cardBody}
                          onScroll={() => onScrollData()}
                        >
                          {isProvactyPolicy ? (
                            <div
                              id="otnotice-f4d306bf-5d80-428d-be47-d8e406eeec9a"
                              className="otnotice"
                              dangerouslySetInnerHTML={{
                                __html: isProvactyPolicy.content,
                              }}
                            ></div>
                          ) : (
                            <></>
                          )}
                          <div
                            id="bottomModal"
                            style={{ marginTop: 50 }}
                          ></div>
                        </Card>
                        <div
                          style={{
                            marginTop: 30,
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Checkbox
                            disabled={isScrollingData}
                            checked={!isPrivacy}
                            onChange={() => setIsPrivacy(!isPrivacy)}
                            style={{ padding: 6 }}
                          >
                            ยอมรับเงื่อนไข
                          </Checkbox>
                          <Button
                            onClick={clossModal}
                            disabled={isPrivacy}
                          >
                            ตกลง
                          </Button>
                        </div>
                      </Modal>
                      <Modal
                        visible={isNetwork}
                        centered
                        footer={false}
                        closeIcon
                        className={styles.modalPolicy}
                      >
                        <Card
                          bordered={false}
                          className={styles.cardBody}
                          onScroll={() => onScrollData()}
                        >
                          <NetworkData />
                          <div
                            id="bottomModal"
                            style={{ marginTop: 50 }}
                          ></div>
                        </Card>
                        <div
                          style={{
                            marginTop: 30,
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Checkbox
                            checked={isCheckedShareData}
                            onChange={(e) =>
                              setIsCheckedShareDat(e.target.checked)
                            }
                            style={{ marginTop: 2, marginRight: 10 }}
                          >
                            ยอมรับเงื่อนไข
                          </Checkbox>
                          <Button onClick={clossModal}>ตกลง</Button>
                        </div>
                      </Modal>
                    </div>

                    <div
                      style={{ display: 'flex', marginBottom: 10 }}
                    >
                      <Checkbox
                        checked={isCheckedNew}
                        onChange={(e) =>
                          setIsCheckedNew(e.target.checked)
                        }
                        style={{ marginTop: 2, marginRight: 10 }}
                      ></Checkbox>
                      <div>
                        <span style={{ fontSize: 14 }}>
                          ข้าพเจ้ายินยอมรับข่าวสารและสิทธิประโยชน์
                          ผ่านทางอีเมล เอสเอ็มเอส แอปพลิเคชัน
                          โซเชียลมีเดีย โทรศัพท์ และไดเร็กเมลจากบริษัท
                          เอสซีจี ดิสทริบิวชั่น จำกัด ผู้ให้บริการ
                          PromptDee
                        </span>
                      </div>
                    </div>

                    <div
                      style={{ display: 'flex', marginBottom: 10 }}
                    >
                      <Checkbox
                        checked={isCheckedShareData}
                        onChange={(e) =>
                          setIsCheckedShareDat(e.target.checked)
                        }
                        style={{ marginTop: 2, marginRight: 10 }}
                      ></Checkbox>
                      <div>
                        <span style={{ fontSize: 14 }}>
                          ข้าพเจ้ายินยอมให้ส่งข้อมูลส่วนบุคคลให้กับ{' '}
                        </span>
                        <span
                          style={{
                            fontSize: 14,
                            color: '#1890FF',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                          onClick={openModalNetwork}
                        >
                          บริษัทในเครือของเอสซีจี บริษัทพันธมิตร
                          และร้านค้าพันธมิตรของพร้อมดี
                        </span>
                        <span style={{ fontSize: 14 }}>
                          {' '}
                          เพื่อรับข่าวสารและสิทธิประโยชน์เกี่ยวกับสินค้าและบริการ
                          ผ่านทางอีเมล เอสเอ็มเอส แอปพลิเคชัน
                          โซเชียลมีเดีย โทรศัพท์ และไดเร็กเมล
                          จากบริษัทดังกล่าว
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col
                    xs={24}
                    lg={24}
                    className={styles.submitWrapper}
                  >
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className={styles.btnSubmit}
                        loading={isLoading}
                      >
                        ลงทะเบียน
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <Modal
        visible={visibleModal}
        centered
        closable={false}
        footer={false}
        onCancel={() => setVisibleModal(false)}
      >
        <img
          className={styles.scgFamPoints}
          src="/images/scg-family-points.png"
        />
        <div>ยืนยันการสมัครสมาชิก SCG Family</div>
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Button key="cancel" onClick={() => setVisibleModal(false)}>
            ยกเลิก
          </Button>
          <Button
            style={{ marginLeft: 8 }}
            key="confirm"
            type="primary"
            onClick={handleConfirmModal}
          >
            สมัครสมาชิก
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Register;
